export namespace RewardId {
  export const LuckyWheel = 1n;
  export const HourlyRakeback = 2n;
  export const DailyRakeback = 3n;
  export const DailyCashback = 4n;
  export const WeeklyCashback = 5n;
  export const MonthlyCashback = 6n;
  export const SportsCashback = 7n;
  export const LevelUp = 8n;
  export const RollCompetition = 9n;
}

export type RewardIdType = (typeof RewardId)[keyof typeof RewardId];
